import React from 'react';
import { Link } from 'react-router-dom';

interface MenuCardProps {
  title: string;
  subtitle: string;
  path: string;
  highlight?: boolean;
}

const MenuCard: React.FC<MenuCardProps> = ({ title, subtitle, path, highlight = false }) => {
  const baseClasses = "group relative flex flex-col items-start justify-between gap-2 overflow-hidden rounded-lg p-5 backdrop-blur-sm transition-all duration-300 ease-in-out active:scale-95";

  const defaultClasses = "border border-white/10 bg-white/5 hover:border-primary/50 hover:bg-white/10";
  const highlightClasses = "border border-white/10 bg-primary/10 ring-1 ring-primary/30 hover:border-primary/50 hover:bg-primary/20";

  const textTitleColor = highlight ? "text-primary" : "text-white";
  const textSubtitleColor = highlight ? "text-primary/80" : "text-white/70";
  const blobColor = highlight ? "bg-primary/10 group-hover:bg-primary/20" : "bg-primary/5 group-hover:bg-primary/10";

  const isExternal = path.startsWith('http') || path.startsWith('https');

  if (isExternal) {
    return (
      <a href={path} target="_blank" rel="noopener noreferrer" className={`${baseClasses} ${highlight ? highlightClasses : defaultClasses}`}>
        <div className={`absolute -right-12 -top-12 h-24 w-24 rounded-full ${blobColor} blur-xl transition-all duration-300`}></div>

        <div className="relative z-10 flex w-full items-center justify-between">
          <h3 className={`text-lg font-bold ${textTitleColor}`}>{title}</h3>
          <span className={`material-symbols-outlined text-primary transition-transform group-hover:translate-x-1`}>
            arrow_forward
          </span>
        </div>
        <p className={`relative z-10 text-sm ${textSubtitleColor}`}>{subtitle}</p>
      </a>
    );
  }

  return (
    <Link to={path} className={`${baseClasses} ${highlight ? highlightClasses : defaultClasses}`}>
      <div className={`absolute -right-12 -top-12 h-24 w-24 rounded-full ${blobColor} blur-xl transition-all duration-300`}></div>

      <div className="relative z-10 flex w-full items-center justify-between">
        <h3 className={`text-lg font-bold ${textTitleColor}`}>{title}</h3>
        <span className={`material-symbols-outlined text-primary transition-transform group-hover:translate-x-1`}>
          arrow_forward
        </span>
      </div>
      <p className={`relative z-10 text-sm ${textSubtitleColor}`}>{subtitle}</p>
    </Link>
  );
};

export default MenuCard;